import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/do';

/**
 * Interceptor that adds the authentication header to request
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /**
   * Intercepts the request and adds the authentication header
   * @param {HttpRequest<any>} req Request
   * @param {HttpHandler}      next HttpHandler
   * @returns {Observable<HttpEvent<any>>} Observable<HttpEvent<any>>
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentAuthHeader = req.headers.get('Authorization');

    // If Authorization header is empty, remove authorization header and pass on the original request
    if (currentAuthHeader === '') {
      req.headers.delete('Authorization');
      return next.handle(req);
    }

    // If Authorization header is already set, pass on the original request
    if (currentAuthHeader !== null) {
      return next.handle(req);
    }

    // Get the auth header from the service.
    const authHeader = localStorage.getItem('UserToken') || '';

    // Clone the request to add the new header.
    const authReq = req.clone({setHeaders: {Authorization: authHeader}});

    // Pass on the cloned request instead of the original request.
    return next.handle(authReq);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/auth.interceptor.ts